import { AxiosResponse } from "axios";
import {
  IStudentPayload,
  IStudent,
  ImportStudentsPayload,
  ImportStudentsResponse
} from "@/models/interfaces/students";

import { getInitialState, updateState } from "@/utils/helpers/StoreUtil";
import DataProvider from "@/utils/helpers/DataProvider";

import { IVuexState } from "@/models/interfaces/store";

import { AxiosError } from "axios";

import { ActionTree, MutationTree, Module } from "vuex";
import { State as RootState } from "@/store";

export interface State {
  students: IVuexState<IStudent[]>;
  student: IVuexState<IStudent>;
}

export const actions: ActionTree<State, RootState> = {
  generateUsername(store, params: { firstname: string; lastname: string }) {
    return DataProvider.get("students/generatedUsername", {
      params
    });
  },

  createStudent(store, payload: IStudentPayload) {
    return DataProvider.post("students", payload);
  },

  editStudent(store, data: { payload: IStudentPayload; studentId: string }) {
    return DataProvider.patch(`students/${data.studentId}`, data.payload);
  },

  async deleteStudents({ commit, state }, studentsIds: string[]) {
    try {
      const { students } = state;
      const deleteRequests = studentsIds.map(id =>
        DataProvider.delete(`students/${id}`)
      );
      const filteredStudents = students.data!.filter(
        ({ userId }) => !studentsIds.includes(userId)
      );

      const result = await Promise.all(deleteRequests);
      commit("setStudents", filteredStudents);
      return result;
    } catch (error) {
      return error;
    }
  },

  async fetchStudentById({ commit }, studentId: string) {
    commit("setStudent");

    return DataProvider.get(`students/${studentId}`)
      .then((response: AxiosResponse) => {
        commit("setStudent", response.data.students[0]);
        return response.data.students[0];
      })
      .catch((error: AxiosError) => {
        commit("setStudent", error);
        return error;
      });
  },

  async importStudents(_, data: ImportStudentsPayload[]) {
    return DataProvider.post<ImportStudentsResponse>("students/imports", data);
  },

  async fetchStudents({ commit }) {
    commit("setStudents");

    return DataProvider.get("students")
      .then((response: AxiosResponse) => {
        commit("setStudents", response.data.students);
        return response.data;
      })
      .catch((error: AxiosError) => {
        commit("setStudents", error);
        return error;
      });
  }
};

export const mutations: MutationTree<State> = {
  setStudents(state, data?: IStudent[] | AxiosError) {
    state.students = updateState(state.students, data);
  },

  setStudent(state, data?: IStudent | AxiosError) {
    state.student = updateState(state.student, data);
  }
};

const store: Module<State, RootState> = {
  namespaced: true,
  state: {
    students: getInitialState(),
    student: getInitialState()
  },
  mutations,
  actions
};

export default store;
